import * as loadQueueHelper from '../../../../js/document/load-queue'
import { fromCamelCase } from '../../../../js/helpers/string'
import { elementFromString } from '../../../../js/document/html-helper'
import { StepsTemplate } from '../c-steps.template'

loadQueueHelper.add(function () {
  renderJsViews()
}, 2)

const renderJsViews = () => {
  // Break if we're not on the targeted tests page
  const keyIdElement = document.getElementById('tests-steps')
  if (!keyIdElement) return
  // Proceed assuming we're there.
  // Load test data, iterate per testCase
  const testData = require('./test-data.json') || []
  testData.forEach(testCase => {
    // Find for the fixtureContainer
    const testCaseId = fromCamelCase(testCase.id)
    const fixtureContainer = keyIdElement.querySelector(`#${testCaseId} .t-docs__test-case__content.t-docs__test-case__content--js`)
    if (!fixtureContainer) return
    // Append fixture where to run the tests
    fixtureContainer.append(
      elementFromString(
        StepsTemplate({ ...testCase.data, steps: testCase.data.steps.map(step => mapStep(step)) })
      )
    )
    // Init components
    // Component.initDocumentComponentsFromAPI(fixtureContainer)
  })
  // ⚠️ IMPORTANT - Add a resolved attribute to keyIdElement letting the tests know when we're done
  keyIdElement.dataset.readyToTest = ''
}

const mapStep = (step) => {
  const stepMapped = {
    text: step.text,
    textMobile: step.textMobile,
    link: {
      href: step.linkUrl,
      target: step.linkTarget,
      title: step.linkTitle
    },
    active: step.active,
    disabled: step.disabled
  }

  return stepMapped
}
